import { render, staticRenderFns } from "./BaseInputTag.vue?vue&type=template&id=c3d4c15e&"
import script from "./BaseInputTag.vue?vue&type=script&lang=js&"
export * from "./BaseInputTag.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputTag.vue?vue&type=style&index=0&id=c3d4c15e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports